import { CandidatoDTO } from '../agendamento/candidatoDTO';
import { FuncionarioDTO } from './funcionarioDTO';
export class UsuarioDTO{

    id!: number;
    login!: string;
    senha!: string;
    nome!:string;
    status!: string;
    perfil!:string;
    ultimoAcesso!: Date;
    funcionario!: FuncionarioDTO;
    candidato!: CandidatoDTO;
    dataAceiteCookies!: Date;
    
}